// Roboto font setup for jsPDF with Cyrillic support
// Uses pre-embedded base64 font data (no async fetching required)

import robotoBase64 from './robotoBase64.js';

/**
 * Setup Roboto font in jsPDF document for Cyrillic support
 * @param {Object} doc - The jsPDF document instance
 * @returns {boolean} - Whether font was successfully set up
 */
export const setupRobotoFont = (doc) => {
  try {
    // Add font to jsPDF virtual file system
    doc.addFileToVFS('Roboto-Regular.ttf', robotoBase64);
    doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
    doc.setFont('Roboto', 'normal');
    return true;
  } catch (error) {
    console.warn('Could not load Roboto font:', error);
    return false;
  }
};

export default setupRobotoFont;
